import { u as U, n as C, q as $, g as F, b as G, p as j, d as k, f as K, e as M, E as Y, M as q, v as B, s as H } from "./export-cdcbfb2b.js";
import { i as L } from "./inherit-if-required-f068457b.js";
import { o as z } from "./object-create-9b6715a2.js";
import { i as J } from "./is-regexp-4c49b1c2.js";
import { t as Q } from "./to-string-92a62764.js";
import { r as V } from "./es.regexp.to-string-e800d529.js";
import { c as X, d as Z, e as W } from "./es.string.replace-f4cc3aea.js";
import { s as rr } from "./set-species-5ede2ed0.js";
var er = U.f, ar = function(t, e, r) {
  r in t || er(t, r, {
    configurable: !0,
    get: function() {
      return e[r];
    },
    set: function(i) {
      e[r] = i;
    }
  });
}, tr = $, P = F, S = G, ir = j, or = L, nr = q, sr = z, cr = C.f, x = B, vr = J, R = Q, fr = V, A = W, ur = ar, lr = k, dr = K, hr = H, mr = M.enforce, Sr = rr, pr = Y, T = X, _ = Z, gr = pr("match"), f = P.RegExp, d = f.prototype, yr = P.SyntaxError, Er = S(d.exec), g = S("".charAt), I = S("".replace), O = S("".indexOf), b = S("".slice), Pr = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, l = /a/g, E = /a/g, xr = new f(l) !== l, D = A.MISSED_STICKY, Rr = A.UNSUPPORTED_Y, Ir = tr && (!xr || D || T || _ || dr(function() {
  return E[gr] = !1, f(l) !== l || f(E) === E || String(f(l, "i")) !== "/a/i";
})), Or = function(t) {
  for (var e = t.length, r = 0, i = "", s = !1, o; r <= e; r++) {
    if (o = g(t, r), o === "\\") {
      i += o + g(t, ++r);
      continue;
    }
    !s && o === "." ? i += "[\\s\\S]" : (o === "[" ? s = !0 : o === "]" && (s = !1), i += o);
  }
  return i;
}, br = function(t) {
  for (var e = t.length, r = 0, i = "", s = [], o = sr(null), v = !1, c = !1, h = 0, n = "", a; r <= e; r++) {
    if (a = g(t, r), a === "\\")
      a += g(t, ++r);
    else if (a === "]")
      v = !1;
    else if (!v)
      switch (!0) {
        case a === "[":
          v = !0;
          break;
        case a === "(":
          if (i += a, b(t, r + 1, r + 3) === "?:")
            continue;
          Er(Pr, b(t, r + 1)) && (r += 2, c = !0), h++;
          continue;
        case (a === ">" && c):
          if (n === "" || hr(o, n))
            throw new yr("Invalid capture group name");
          o[n] = !0, s[s.length] = [n, h], c = !1, n = "";
          continue;
      }
    c ? n += a : i += a;
  }
  return [i, s];
};
if (ir("RegExp", Ir)) {
  for (var u = function(e, r) {
    var i = x(d, this), s = vr(e), o = r === void 0, v = [], c = e, h, n, a, y, p, m;
    if (!i && s && o && e.constructor === u)
      return e;
    if ((s || x(d, e)) && (e = e.source, o && (r = fr(c))), e = e === void 0 ? "" : R(e), r = r === void 0 ? "" : R(r), c = e, T && "dotAll" in l && (n = !!r && O(r, "s") > -1, n && (r = I(r, /s/g, ""))), h = r, D && "sticky" in l && (a = !!r && O(r, "y") > -1, a && Rr && (r = I(r, /y/g, ""))), _ && (y = br(e), e = y[0], v = y[1]), p = or(f(e, r), i ? this : d, u), (n || a || v.length) && (m = mr(p), n && (m.dotAll = !0, m.raw = u(Or(e), h)), a && (m.sticky = !0), v.length && (m.groups = v)), e !== c)
      try {
        nr(p, "source", c === "" ? "(?:)" : c);
      } catch {
      }
    return p;
  }, w = cr(f), N = 0; w.length > N; )
    ur(u, f, w[N++]);
  d.constructor = u, u.prototype = d, lr(P, "RegExp", u, { constructor: !0 });
}
Sr("RegExp");
